<template>
  <v-card class="mt-4 pa-0">
    <LoadingIndicator
      v-if="policyStore.policyInfoLoading"
      :loading="policyStore.policyInfoLoading"
    />
    <OnexDialog
      type="warning"
      v-model="showMessageDialog"
      @close="showMessageDialog = false"
      @closeDialog="showMessageDialog = false"
      @clickOutside="showMessageDialog = false"
    >
      <template #title>{{ $t('L_payment_in_process') }}</template>
      <template #text>{{ $t('L_a_payment_is_currently_being_processed') }}</template>
      <template #yesBtn>{{ $t('L_close') }}</template>
    </OnexDialog>
    <v-container class="pa-0" v-if="indexPolicy !== -1 && !policyStore.policyInfoLoading">
      <!-- <div>
        selectedPolicy: {{ selectedPolicy }} <br />
      </div> -->
      <!-- ! Your policy will be terminated alert header -->
      <TermLifeCardYourPolicyWillBeTerminatedAlert
        v-if="isH1BillingForm && !isAccessNone"
        :index-policy="indexPolicy"
      />
      <!-- ! Policy Number and status -->
      <TermLifeCardHeader :index-policy="indexPolicy" />
      <!-- ! Pay Now blue/green bar banner OR Payment in process -->
      <TermLifeCardPaymentAlert :index-policy="indexPolicy" />
      <!-- ! Policy Access None -->
      <TermLifeCardPolicyAccessNone v-if="isAccessNone" />
      <!-- ! ChildRider Banner -->
      <ChildRiderAlert
        v-if="hasCRCPackageForCurrentPolicy && !isAccessNone"
        :index-policy="indexPolicy"
      />
      <!-- ! Total Coverage section-->
      <TermLifeCardCoverageSection
        v-if="!isEligibleForReinstatement && !isAccessNone"
        :index-policy="indexPolicy"
      />
    </v-container>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { openInNewWindow } from '@/mixins/openNewWindow';
import ChildRiderAlert from '@/modules/childrider/components/ChildRiderAlert/ChildRiderAlert.vue';
import { useChildRiderStore } from '@/modules/childrider/store/childrider.store';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import { OnexDialog } from '@primerica/onex-ui-lib';
import { mdiAlertCircle, mdiCheckCircle, mdiClockTimeFour, mdiFileDocument } from '@mdi/js';
import TermLifeCardYourPolicyWillBeTerminatedAlert from './TermLifeCardYourPolicyWillBeTerminatedAlert.vue';
import TermLifeCardHeader from './TermLifeCardHeader.vue';
import TermLifeCardPaymentAlert from './TermLifeCardPaymentAlert.vue';
import TermLifeCardPolicyAccessNone from './TermLifeCardPolicyAccessNone.vue';
import TermLifeCardCoverageSection from './TermLifeCardCoverageSection.vue';
import { BillingForm } from '@/shared/util/stringValues';
import { mapState, mapStores } from 'pinia';
import { usePolicyStore } from '@/modules/policy/store/policy.store';

const componentOptions: ComponentOptions = {
  name: 'TermLifeCard',
  mixins: [openInNewWindow],
  components: {
    LoadingIndicator,
    OnexDialog,
    TermLifeCardYourPolicyWillBeTerminatedAlert,
    TermLifeCardHeader,
    TermLifeCardPaymentAlert,
    ChildRiderAlert,
    TermLifeCardPolicyAccessNone,
    TermLifeCardCoverageSection,
  },
  data: () => ({
    showMessageDialog: false,
    mdiFileDocument,
    mdiCheckCircle,
    mdiAlertCircle,
    mdiClockTimeFour,
  }),
  props: {
    indexPolicy: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    ...mapState(usePolicyStore, ['policies']),
    selectedPolicy() {
      const selectedPolicy: IPolicyStorePolicy = this.policyStore.policies[this.indexPolicy];
      return selectedPolicy;
    },
    isAccessNone() {
      return this.selectedPolicy?.data?.access === 'NONE';
    },
    isH1BillingForm() {
      return this?.selectedPolicy?.billingForm === BillingForm.H1;
    },
    isEligibleForReinstatement() {
      return (
        this.selectedPolicy?.reinstatement && this.selectedPolicy?.reinstatement?.eligible === true
      );
    },
    hasCRCPackageForCurrentPolicy(): boolean {
      if (this.indexPolicy === -1) {
        return false;
      }
      return !!(
        this.childriderStore.hasPackageGivenPolicyId(
          this.policyStore.policies[this.indexPolicy].contractId
        ) &&
        (this.policyStore.policies[this.indexPolicy]?.billingForm === BillingForm.A1 ||
          this.policyStore.policies[this.indexPolicy]?.billingForm === BillingForm.B2 ||
          this.policyStore.policies[this.indexPolicy]?.billingForm === BillingForm.C2 ||
          this.policyStore.policies[this.indexPolicy]?.billingForm === BillingForm.D2 ||
          this.policyStore.policies[this.indexPolicy]?.billingForm === BillingForm.H1)
      );
    },
    ...mapStores(usePolicyStore, useChildRiderStore),
  },
};

export default defineComponent(componentOptions);
</script>
